import React from "react";
import "./RegistrationForm.css";
import logoImg from "../../assets/logos/white-logo.svg";
import { useState } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { AuthService } from "../ApiServices/AuthApi";
import { RoleId } from "../Enum/RoleId";
import Feedback from "../FeedbackModal/Feedback";
import LoginForm from "../LoginFormModal/LoginForm";
import { useNavigate } from "react-router-dom";
import { status } from "nprogress";

export default function RegistrationForm({ onClose }) {
  const navigate = useNavigate();

  const service = AuthService();
  const [FormData, setFormData] = useState({
    user_name: "",
    email: "",
    phone_number: "",
    password: "",
    confirm_password: "",
  });

  const [showModel, setShowModal] = useState(false);
  const [isSuccess, setisSuccess] = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const [showRegistration , setshowRegistration] = useState(true);
  const [showPassword, setshowPassword] = useState(false);

  function togglePassword() {
    setshowPassword((prev) => !prev);
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (FormData.password !== FormData.confirm_password) {
      setShowModal(true);
      setisSuccess({
        status: "failure",
        title: "Failed",
        message: "Make Sure Password or confirm Password are same",
        show: true,
      });
      return;
    }

    try {
      const payload = {
        user_name: FormData.user_name,
        email: FormData.email,
        phone_number: FormData.phone_number,
        password: FormData.password,
        role_id: RoleId.User,
      };

      const response = await service.RegisterUser(payload); // Call the correct method

      if (response.result == 1) {
        setShowModal(true);
        setisSuccess({
          status: "success",
          title: "Success",
          message: "You Registered Successfully",
          show: true,
        });
        // setShowLogin(true);
      } else if (response.result == 0) {
        var Error_value = response.error_value.errorText;

        setShowModal(true);
        setisSuccess({
          status: "failure",
          title: "Failed",
          message: Error_value,
          show: true,
        });
      }

      // Reset form
      setFormData({
        user_name: "",
        email: "",
        phone_number: "",
        password: "",
        confirm_password: "",
      });
    } catch (error) {
      // console.error('Error:', error);
      // alert("Registration failed!"+error);
      setShowModal(true);
      setisSuccess({
        status: "failure",
        title: "Failed",
        message: Error_value,
        show: true,
      });
    }
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  return (
    <>
    {showRegistration && (
      <div className="registration_modal_overlay">
        <div className="registration_modal_cross">
          <i class="bi bi-x-lg close_icon" onClick={onClose}></i>
        </div>
        <div className="registration_modal">
          <div className="left-panel">
            <div className="profile">
              <img src={logoImg} alt="Profile" />
              <h3>Tech Features</h3>
              <p>
                At TechFeatures, we’re committed to providing seamless
                technology solutions that empower businesses and individuals
                alike. Create your account to access exclusive insights,
                innovative tools, and personalized support tailored to your
                needs. Your journey towards smarter tech starts here.
              </p>
            </div>
          </div>

          <div className="right-panel">
            <h2>Create Your Account</h2>

            <form className="registration-form" onSubmit={handleSubmit}>
              <div>
                <input
                  type="text"
                  name="user_name"
                  value={FormData.user_name}
                  placeholder="Full Name"
                  onChange={handleChange}
                />
              </div>
              <div>
                <input
                  type="email"
                  name="email"
                  value={FormData.email}
                  placeholder="Enter Email"
                  onChange={handleChange}
                  required
                />
              </div>
              <div>
                <input
                  type="tel"
                  name="phone_number"
                  value={FormData.phone_number}
                  placeholder="Enter Phone (Optional)"
                  onChange={handleChange}
                />
              </div>
              <div>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={FormData.password}
                  placeholder="Password"
                  onChange={handleChange}
                  required
                />
              </div>
              <span>
                <input
                  type={showPassword ? "text" : "password"}
                  name="confirm_password"
                  value={FormData.confirm_password}
                  placeholder="Confirm Password"
                  onChange={handleChange}
                  required
                />
              </span>
              <span
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
                onClick={togglePassword}
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                <label htmlFor="id" style={{ margin: 0, cursor: "pointer" }}>
                  Show password
                </label>
              </span>

              <button type="submit" className="btn primary_btn">
                Register Now
              </button>
            </form>
          </div>
        </div>
      </div>

      )}

      {/* {showModel && (
        <Feedback
            isSuccess={isSuccess}
          onClose={() => {
            
            setisSuccess(null);
            setShowModal(false);

          }}
        />
      )} */}

      {showModel && (
        <Feedback
          isSuccess={isSuccess}
          onClose={() => {
            if (isSuccess.title === "Success") {
              setShowModal(false);
              setshowRegistration(false);
              setShowLogin(true);
             //navigate('/UserLogin');
            } else {
              setShowModal(false);
              setisSuccess(null);
            }
          }}
        />
      )}

      {showLogin && <LoginForm onClose={() => setShowLogin(false)} />}
        
    </>
  );
}
